export const Paths = {
  AUTH_QUEUE: "/auth-queue",
  SIGNUP: "signup",
  LOG_IN: "login",
  LOG_OUT: "logout",
  //Onbaording paths
  ONBOARDING: "onboarding",
  PAYMENT_CONFIRMATION: "payment-confirmation",
  STATE_SELECTION: "state-selection",
  QUESTIONS: "questions",
  REFILL: "refill",
  REGISTRATION: "registration",
  ADD_ONS: "add-ons",

  //Patient dashboard paths
  PATIENT_DASHBOARD: "/patient-dashboard",
  MESSAGING: "/messaging",
  CARE: "/care",
  ONE_TIME_PAYMENT_INFORMATION: "ot-payment-information",
  SHOP: "/shop",
  GLP1: "/glp-1",
  REFERRALS: "/referrals",
  CANCELLATION: "cancellation",
  //Patient account paths
  MY_ACCOUNT: "/my-account",
  MY_ACCOUNT_OVERVIEW: "overview",
  MY_ACCOUNT_TRANSACTION_HISTORY: "transaction-history",
  MY_ACCOUNT_INSURANCE_DETAILS: "insurance-details",
  MY_ACCOUNT_PREFERRED_PHARMACY: "preferred-pharmacy",
  MY_ACCOUNT_HELP_CENTER: "help-center",
  MY_PAYMENT_METHODS: "payment-methods",
  MY_SUBSCRIPTIONS: "subscriptions",
};
